import {Container} from '@/components/ui/container/Container'
import styled, {css} from 'styled-components'

export const StyledLoadingAgendaContainer = styled(Container)(
    ({theme: {palette, zIndex, opacities}}) => css`
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: ${zIndex.modal};
        background-color: ${palette.neutral['100']}${opacities['20']};
        backdrop-filter: blur(12px);

        & svg {
            color: ${palette.neutral['500']};
        }
    `
)

export const StyledAgendaCalendarWrapper = styled.div(
    ({theme: {typography, palette, spacing, opacities}}) => css`
        padding: ${spacing * 4}px;
        overflow: hidden;
        position: relative;
        overflow-x: auto;

        // Hide Sunday cells completely in week view
        .hide-holidays .rbc-time-view .rbc-day-slot.disabled-day,
        .hide-holidays .rbc-time-header-content .rbc-header.disabled-day {
            display: none;
        }

        .rbc-calendar {
            border-radius: 8px;
            background-color: ${palette.neutral['white']};
            border: 1px solid ${palette.neutral['200']};
            width: 100%;
            min-width: 1000px;
            overflow: hidden;
        }

        .rbc-day-bg + .rbc-day-bg {
            border-left: 1px solid ${palette.neutral['200']};
        }

        .rbc-month-view {
            border: none;
        }

        .rbc-month-row + .rbc-month-row {
            border-top: 1px solid ${palette.neutral['200']};
        }

        & .rbc-time-view {
            border: none;
        }

        & .rbc-date-cell {
            padding: ${spacing}px;
        }

        & div.rbc-header {
            ${typography.textXs};
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            border-bottom: 1px solid ${palette.neutral['200']};
            min-height: 32px;
            padding: 0;
        }

        & .rbc-event {
            background-color: transparent;
            border: none;
            overflow: visible;
            height: 36px;
        }

        & .rbc-event.tentative {
            pointer-events: none;
        }

        & .rbc-timeslot-group {
            min-height: 160px;
        }

        & .rbc-event-label {
            display: none;
        }

        & .rbc-time-slot {
            ${typography.textXs};
            text-align: center;
            min-width: 50px !important;
            min-height: 70px !important;
        }

        & .rbc-label {
            min-width: 50px !important;
            padding: 0 ${spacing * 2}px;
        }

        & .rbc-day-slot .rbc-events-container {
            border-left: none;
            margin: 0;
        }

        .rbc-events-container > .rbc-event {
            outline: none;
        }

        .rbc-day-slot .rbc-background-event {
            background-color: transparent;
            outline: none;
            border: none;
            cursor: default;
        }

        .rbc-day-slot.rbc-today,
        .rbc-day-bg.rbc-today,
        .rbc-header.rbc-today {
            background-color: transparent;
        }

        .rbc-today .day-number,
        .rbc-now .day-number {
            background-color: ${palette.primary['500']};
            color: ${palette.neutral['white']};
        }

        & .rbc-row-segment .rbc-event-content {
            overflow: visible;
            height: 100%;
        }

        & .rbc-off-range-bg {
            background: ${palette.neutral['50']};
        }

        & .rbc-time-view .rbc-current-time-indicator {
            background-color: ${palette.red['600']};
            height: 2px;
        }

        /* & .rbc-time-view:not(.rbc-time-view-resources) .rbc-current-time-indicator {
            &::before {
                content: '';
                display: none;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                transform: translateY(-5px) translateX(-50%);
                background-color: ${palette.red['600']};
            }
        } */

        /* rbc-time-view-resources */

        /* Hide all day events row */
        .rbc-allday-cell {
            display: none;
        }

        /* Hide all day events header */
        .rbc-time-view .rbc-header,
        .rbc-time-header-content > .rbc-row.rbc-row-resource {
            border-bottom: none;
        }

        & .rbc-event > .rbc-addons-dnd-resizable,
        & .rbc-background-event > .rbc-addons-dnd-resizable {
            width: 100%;
            height: 100%;
        }

        .rbc-addons-dnd .rbc-addons-dnd-resize-ns-anchor .rbc-addons-dnd-resize-ns-icon {
            border-color: ${palette.neutral['500']}${opacities[50]};
        }

        .rbc-time-header-content {
            border-left: none;
            box-shadow: inset 1px 0px 1px ${palette.neutral['200']};
        }

        /* Hide resource gutter border */
        .rbc-time-view-resources .rbc-time-gutter {
            border-right: none;
            box-shadow: inset -1px 0px 1px ${palette.neutral['200']};
        }

        .rbc-time-header.rbc-overflowing {
            border-right: none;
        }

        /* Agenda view */
        & .rbc-agenda-view > table.rbc-agenda-table {
            display: none;
        }

        .rbc-agenda-view table.rbc-agenda-table tbody > tr > td:not(.rbc-agenda-date-cell) {
            vertical-align: middle;
        }

        .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
            border: none;
        }

        .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
            border-top: none;
        }

        .rbc-agenda-view .rbc-agenda-date-cell {
            min-width: 150px;
        }

        .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
            padding: ${spacing * 2}px ${spacing * 4}px;
        }

        .rbc-agenda-table > tbody tr:has(> td.rbc-agenda-date-cell):not(:first-child) {
            border-top: 1px solid ${palette.neutral['200']};
        }

        .rbc-agenda-empty {
            ${typography.textSm};
            padding: ${spacing * 4}px;
            color: ${palette.neutral['500']};
        }

        .disabled-day {
            background: repeating-linear-gradient(
                -45deg,
                ${palette.neutral['100']} 0px,
                ${palette.neutral['100']} 10px,
                transparent 10px,
                transparent 20px
            );
        }

        /* Blockout day styling for month view */
        .blockout-day .rbc-background-event {
            padding: 0;
        }

        .rbc-header.blockout-day,
        .rbc-header.disabled-day {
            background: none;
        }

        /* Background events styling */
        .rbc-day-bg .rbc-background-event {
            display: none; /* Hide the actual background event elements, we're handling them with dayPropGetter */
        }

        /* Slot selection styling */
        .rbc-slot-selection {
            color: ${palette.primary['500']};
            font-weight: 500;
            background-color: ${palette.primary['50']};
            border: 2px solid ${palette.primary['300']};
            border-radius: 8px;
        }

        /* Resources view */
        /* .rbc-time-view-resources .rbc-day-slot, */
        .rbc-time-header-content {
            min-width: 250px;
        }

        .rbc-time-view-resources .rbc-day-slot {
            min-width: 249px;
        }
    `
)
